import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cabinet-page-head" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 1,
  class: "cabinet-page-head__view-switch"
}
const _hoisted_5 = { class: "toggle-cabinet-table-view" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.layout), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.fallbackRouteName)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "cabinet-page-head__back-link",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
            }, [
              _createVNode(_component_AppIcon, {
                name: "i-arrow-left",
                size: "xl"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          class: "cabinet-page-head__title",
          title: $setup.currentTitle?.title || $setup.currentTitle
        }, [
          _createTextVNode(_toDisplayString($setup.currentTitle?.title || $setup.currentTitle), 1),
          ($setup.currentTitle?.subTitle)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "cabinet-page-head__subtitle",
                title: $setup.currentTitle?.subTitle
              }, _toDisplayString($setup.currentTitle?.subTitle), 9, _hoisted_3))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2),
        ($setup.canChangeTableView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["toggle-cabinet-table-view__el", { 'is-active': !$setup.storageTableView}]),
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleTableAsCards(false))),
                  "aria-label": _ctx.$t('Set table view as cards')
                }, [
                  _createVNode(_component_AppIcon, {
                    name: "i-grid",
                    "aria-hidden": "true",
                    size: "xl"
                  })
                ], 10, _hoisted_6),
                _createElementVNode("button", {
                  class: _normalizeClass(["toggle-cabinet-table-view__el", { 'is-active': $setup.storageTableView}]),
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleTableAsCards(true))),
                  "aria-label": _ctx.$t('Reset table view')
                }, [
                  _createVNode(_component_AppIcon, {
                    name: "i-dice",
                    "aria-hidden": "true",
                    size: "xl"
                  })
                ], 10, _hoisted_7)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_RouterView, {
        onCanChangeMobileTableView: _cache[3] || (_cache[3] = ($event: any) => ($setup.canChangeTableView = true))
      })
    ]),
    _: 1
  }))
}